import React from 'react'
import { Typography } from '@material-ui/core';

export default function SectionHeading({children}) {
    return ( <Typography 
            style={{ 
                flex : 1, 
                margin : '10px 0', 
                textAlign: 'center', 
                fontSize:'18px', 
            }}>{children} </Typography>)
    
}